import { TableConfig } from '@shared/interfaces/table/table-config';

export const roleTableConfig: TableConfig<any> = {
  pagination: false,
  columns: [
    {
      title: 'role.title',
      key: 'role'
    },
    {
      title: 'role.description',
      key: 'description'
    }
  ]
}
